// External imports
import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { ThemeProvider} from '@mui/material/styles';

// Local imports
import { theme } from './style';
import { router } from './routes';
import { Authenticator } from '@aws-amplify/ui-react';

// Component definition
function App() {
  return (
    <ThemeProvider theme={theme}>
       <Authenticator.Provider>
        <RouterProvider router={router} />
      </Authenticator.Provider>
    </ThemeProvider>
  );
}

// Default export
export default App;
